import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Col,
  Progress,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import AttendanceModel from "models/Attendance.modal";
import { Link } from "react-router-dom";
import classModal from "models/class.modal";
import Loader from "components/loader/Loader";


const Classes = () => {
  const [modal, setModal] = useState(false);
  const [status, setStatus] = useState("?class_status=All");
  const toggleModal = (modalName) => {
    setModal(!modal);
  };
  const [totalpage, setTotalpage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    await AttendanceModel.GetAllCLass(status, parameters)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          console.log("class",result)
          setDataList(result?.data || { data: [] });
          setTotalpage(result?.meta?.total_page)
          setCurrentPage(result?.data?.meta?.current_page);
          setPerPage(result?.data?.meta?.per_page);
        }
      })
      .catch((error) => {
       console.log("error",error)
       setIsLoading(false);
       setDataList({ data: [] }); // Set empty data structure on error to trigger dummy data
      });
  };
  useEffect(() => {
    getListData();
  }, [currentPage]);


  const[alldata,setAlldata]=useState();
  const[activedata,setActivedata]=useState();
  const[holddata,setHolddata]=useState();
  const[completedata,setCompletedata]=useState();
  const[discontinuedata,setDiscontinueddata]=useState();
  const[smedata,setSmedata]=useState();
  const[ccombineddata,setCombineddata]=useState();
  const[sepratedata,setSeprateddata]=useState();

  const getListDatacount = async () => {
    await AttendanceModel.GetAllCLass("?class_status=All")
      .then((result) => {
        setAlldata(result?.data?.data);
      })
      .catch((error) => {
       console.log("error",error)
      });
      await AttendanceModel.GetAllCLass("?class_status=Active")
      .then((result) => {
        setActivedata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
      await AttendanceModel.GetAllCLass("?class_status=Hold")
      .then((result) => {
        setHolddata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
      await AttendanceModel.GetAllCLass("?class_status=Completed")
      .then((result) => {
        setCompletedata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
      await AttendanceModel.GetAllCLass("?class_status=Discontinued")
      .then((result) => {
        setDiscontinueddata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
      await AttendanceModel.GetAllCLass("?class_type=SME")
      .then((result) => {
        setSmedata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
      await AttendanceModel.GetAllCLass("?class_type=COMBINED")
      .then((result) => {
        setCombineddata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error);
      });
      await AttendanceModel.GetAllCLass("?class_type=SEPARATE")
      .then((result) => {
        setSeprateddata(result?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
  };
  useEffect(() => {
    getListData();
    getListDatacount();
  }, [location]);
  useEffect(() => {
    getListData();
  }, [status]);
  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          classModal.deleteclass(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };

  const [searchTerm, setSearchTerm] = useState("");

  // Dummy data for testing when no API data is available
  const dummyClassData = [
    {
      _id: 1,
      id: 1,
      name: "Mathematics Grade 10",
      mode: "Online",
      status: "Active",
      student_data: [{ name: "Aarav Sharma" }],
      studentApi_parent: {
        user_id: 1,
        auth_user: {
          first_name: "Rajesh",
          last_name: "Sharma"
        }
      },
      tutorApi_tutor: {
        auth_user: {
          first_name: "Dr. Priya",
          last_name: "Patel"
        }
      },
      attendanceData: {
        date: "2024-12-15"
      },
      adminApi_classcycle: {
        total_duration: 100,
        remaining_duration: 30
      }
    },
    {
      _id: 2,
      id: 2,
      name: "Physics Grade 11",
      mode: "Offline",
      status: "Active",
      student_data: [{ name: "Kavya Gupta" }],
      studentApi_parent: {
        user_id: 2,
        auth_user: {
          first_name: "Sunita",
          last_name: "Gupta"
        }
      },
      tutorApi_tutor: {
        auth_user: {
          first_name: "Prof. Rahul",
          last_name: "Singh"
        }
      },
      attendanceData: {
        date: "2024-12-14"
      },
      adminApi_classcycle: {
        total_duration: 80,
        remaining_duration: 50
      }
    },
    {
      _id: 3,
      id: 3,
      name: "Chemistry Grade 12",
      mode: "Hybrid",
      status: "Hold",
      student_data: [{ name: "Arjun Kumar" }],
      studentApi_parent: {
        user_id: 3,
        auth_user: {
          first_name: "Amit",
          last_name: "Kumar"
        }
      },
      tutorApi_tutor: {
        auth_user: {
          first_name: "Dr. Meera",
          last_name: "Joshi"
        }
      },
      attendanceData: {
        date: "2024-12-10"
      },
      adminApi_classcycle: {
        total_duration: 120,
        remaining_duration: 90
      }
    },
    {
      _id: 4,
      id: 4,
      name: "English Literature",
      mode: "Online",
      status: "Completed",
      student_data: [{ name: "Diya Raman" }],
      studentApi_parent: {
        user_id: 4,
        auth_user: {
          first_name: "Lakshmi",
          last_name: "Raman"
        }
      },
      tutorApi_tutor: {
        auth_user: {
          first_name: "Ms. Sarah",
          last_name: "Johnson"
        }
      },
      attendanceData: {
        date: "2024-12-12"
      },
      adminApi_classcycle: {
        total_duration: 60,
        remaining_duration: 0
      }
    },
    {
      _id: 5,
      id: 5,
      name: "Computer Science",
      mode: "Online",
      status: "Discontinued",
      student_data: [{ name: "Rohan Mehta" }],
      studentApi_parent: {
        user_id: 5,
        auth_user: {
          first_name: "Vikram",
          last_name: "Mehta"
        }
      },
      tutorApi_tutor: {
        auth_user: {
          first_name: "Mr. Anil",
          last_name: "Verma"
        }
      },
      attendanceData: {
        date: "2024-12-08"
      },
      adminApi_classcycle: {
        total_duration: 90,
        remaining_duration: 70
      }
    }
  ];

  const filteredData = dataList?.data?.length > 0 
    ? dataList.data.filter((item) => {
        return (
          item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.tutor?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.parent?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.mode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      })
    : dummyClassData.filter((item) => {
        const tutorName = `${item?.tutorApi_tutor?.auth_user?.first_name || ""} ${item?.tutorApi_tutor?.auth_user?.last_name || ""}`;
        const parentName = `${item?.studentApi_parent?.auth_user?.first_name || ""} ${item?.studentApi_parent?.auth_user?.last_name || ""}`;
        const studentName = item?.student_data?.[0]?.name || "";
        
        return (
          item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tutorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          parentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.mode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });


console.log("class pagination",dataList)
  return (
    <>
      <div className="pt-7 px-4 overflow-x-hidden ">
        <Row>
          <div className="col">
            <Card className="shadow">
              <div style={{ marginTop: "20px" }}>
                <Row
                  className="mb-1 px-4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Col
                    md={7}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      border: "1px solid black",
                    }}
                  >
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: status == "?class_status=All" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=All");
                      }}
                    >
                      <span>All</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=All" ? "black" : "blue",
                          }}
                        >
                          {alldata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Active" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Active");
                      }}
                    >
                      <span>Active Class</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Active"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {activedata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Hold" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Hold");
                      }}
                    >
                      <span>Hold</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Hold" ? "black" : "blue",
                          }}
                        >
                          {holddata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Completed"
                            ? "blue"
                            : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Completed");
                      }}
                    >
                      <span>Completed</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Completed"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {completedata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Discontinued"
                            ? "blue"
                            : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Discontinued");
                      }}
                    >
                      <span>Discontinued</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Discontinued"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {discontinuedata?.length}
                        </span>
                        )
                      </span>
                    </div>
                  </Col>
                  <Col md={1}></Col>
                  <Col
                    md={4}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      border: "1px solid black",
                    }}
                  >
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: status == "?class_type=SME" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=SME");
                      }}
                    >
                      <span>SME</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_type=SME" ? "black" : "blue",
                          }}
                        >
                          {smedata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_type=COMBINED" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=COMBINED");
                      }}
                    >
                      <span>Combined</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_type=COMBINED"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {ccombineddata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_type=SEPARATE" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=SEPARATE");
                      }}
                    >
                      <span>Separate</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_type=SEPARATE"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {sepratedata?.length}
                        </span>
                        )
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>

              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Classes</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term on input change
                  />
                {/*  <Button
                    size="sm"
                    to="/admin/classes/addclasss"
                    tag={Link}
                    color="primary"
                    style={{
                      width: "60%",
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    +Add Class
                  </Button>*/}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">SN NO.</th>
                    <th scope="col">Class Name</th>
                    <th scope="col">Student</th>
                    <th scope="col">TUTOR</th>
                    <th scope="col">Last Attendance Marked</th>
                    <th scope="col">Mode</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                  <tbody>
                  {isLoading ? (
                  <tr>
                    <td colSpan={9} className="text-center align-middle py-4">
                      Please wait...
                      <Loader/>
                    </td>
                  </tr>
                ) :filteredData?.length > 0 ? (
                      filteredData?.map((item, index) => {
                        const totalDuration =
                          item?.adminApi_classcycle?.total_duration || 0;
                        const remainingDuration =
                          item?.adminApi_classcycle?.remaining_duration || 0;

                        const progressPercentage =
                          totalDuration > 0
                            ? ((totalDuration - remainingDuration) /
                                totalDuration) *
                              100
                            : 0;

                           
                        return (
                          <tr key={item._id} style={{ cursor: "pointer" }}>
                            <td style={{ padding: "0.1rem" }}>
                              {(currentPage - 1) * perPage + index + 1}
                            </td>
                            <td style={{ padding: "0.1rem" }}>
                              {item?.name || "-"}
                            </td>
                            <td style={{ padding: "0.1rem" }}>
                              <span
                                style={{ fontSize: "14px", color: "skyblue" }}
                              >
                                {item?.student_data?.map((item, index) => {
                                  return <>{item?.name}</>;
                                }) || "-"}
                              </span>
                              <p style={{ fontSize: "14px", color: "black" }}>
                                Client -{" "}
                                <span
                                  style={{ fontSize: "14px", color: "skyblue" }}
                                >
                                  {
                                    item?.studentApi_parent?.auth_user
                                      ?.first_name
                                  }{" "}
                                  {
                                    item?.studentApi_parent?.auth_user
                                      ?.last_name
                                  }
                                </span>
                              </p>
                            </td>
                            <td style={{ padding: "0.1rem" }}>
                              {item?.tutorApi_tutor?.auth_user?.first_name}{" "}
                              {item?.tutorApi_tutor?.auth_user?.last_name}
                            </td>
                            <td style={{ padding: "0.1rem" }}>
                              <span>{item?.attendanceData?.date}</span>
                              <Progress
                                className="my-2"
                                value={progressPercentage}
                                style={{ height: "25px" }}
                              >
                                {Math.round(progressPercentage)}%
                              </Progress>
                            </td>
                            <td style={{ padding: "0.1rem" }}>
                              {item?.mode || "-"}
                            </td>
                            <td style={{ padding: "0.1rem" }}>
                              <span
                                style={{
                                  backgroundColor: "green",
                                  padding: "2px 5px",
                                  color: "white",
                                  borderRadius: "20px",
                                }}
                              >
                                {item?.status || "-"}
                              </span>
                            </td>
                            <td
                              className=""
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                padding: "0.1rem",
                              }}
                            >
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  display: "inline-block",
                                  marginTop: "14px",
                                  borderRadius: "30%",
                                }}
                                id="view"
                                to={`/admin/classes/classsummary/${item?.studentApi_parent?.user_id}/${item?.id}`}
                              >
                                <i className="fa-solid fa-eye"></i>
                              </Link>

                              <p
                                style={{
                                  margin: "0 8px",
                                  fontSize: "15px",
                                  color: "red",
                                  marginTop: "14px",
                                  display: "inline-block",
                                  borderRadius: "20%",
                                }}
                                id="userTooltip"
                                onClick={() => handleDel(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
               
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                   totalPages={dataList?.meta?.total_page}
                   currentPage={dataList?.meta?.current_page}
                  pageUrl="/admin/classes?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default Classes;
